'use client';

import useTranslation from 'next-translate/useTranslation';
import { useContext, useEffect, useRef, useState } from 'react';
import flush from 'just-flush';
import { defaultLanguage } from '@stereoagency/constants';
import { Container, NewsGridSection, TagFilter } from '@stereoagency/ui';
import { articlesQuery } from './articlesQuery';
import {
  articleAsProps,
  filterOptionsFromDocuments,
  findInKeyArray
} from '@/utils';
// import type { RouteResultType } from '@/app/(root)/api/data/article/route';
import { useClientUrl } from '@/hooks';
import { SpecialPagesContext } from '@/components/context';

type Props = {
  enableTaxonomyFilter?: boolean;
  articles: (typeof articlesQuery)[1];
  totalCount?: number;
  taxonomyCounts?: Record<string, number>;
};

// const articlesFetcher = async (offset: number) => {
//   const url = new URL('/api/data/article', window.location.href);
//   url.searchParams.append('offset', String(offset));

//   const response = await fetch(url.toString());
//   const data = await response.json();
//   return data as RouteResultType;
// };

export default function ArticleListingSection({
  enableTaxonomyFilter,
  taxonomyCounts,
  totalCount,
  articles
}: Props) {
  const { t, lang } = useTranslation();
  const url = useClientUrl();
  const specialPagesValue = useContext(SpecialPagesContext);
  const containerRef = useRef<HTMLDivElement | null>(null);
  // const [offset, setOffset] = useState<number | null>(null);
  const [selected, setSelected] = useState<string[]>(['all']);

  const data = articles;

  // const { data, isLoading } = useSWR(
  //   () => offset,
  //   async (key: number): Promise<RouteResultType> => {
  //     const result = await articlesFetcher(key);
  //     return (data ?? []).concat(result);
  //   },
  //   {
  //     keepPreviousData: true,
  //     revalidateOnReconnect: false,
  //     revalidateOnFocus: false,
  //     revalidateIfStale: false
  //   }
  // );

  // const moreKey = `${articles.length + (data?.length ?? 0)}-${selected.join(
  //   '/'
  // )}`;

  // useLoadMoreData(containerRef, moreKey, () => {
  //   if (isLoading) throw new Error('already loading');
  //   setOffset((offset ?? 0) + 20);
  // });

  const allArticles = [...(data ?? [])];
  const filteredArticles = allArticles.filter((article) => {
    if (selected.length === 1 && selected[0] === 'all') return true;
    if (!article.taxonomies?.length) return false;
    return article.taxonomies.some(
      (tax) => tax.slug?.current && selected.includes(tax.slug.current)
    );
  });

  const filters = filterOptionsFromDocuments(
    articles,
    (doc) =>
      flush(
        doc.taxonomies?.map((tax) => {
          const name = tax.name
            ? findInKeyArray(tax.name, [lang, defaultLanguage.id])
            : null;
          if (!tax.slug?.current || !name?.value) return null;
          return { label: name.value, value: tax.slug.current };
        }) ?? []
      ),
    taxonomyCounts
  );

  const filtersParam = url?.searchParams.get('filters');

  useEffect(() => {
    const filtersParamOptions = flush(
      (filtersParam?.split(',') ?? []).map((value) =>
        filters.find((entry) => entry.value === value)
      )
    );
    if (filtersParamOptions.length) {
      setSelected(filtersParamOptions.map((opt) => opt.value));
      // setOffset(articles.length + (data?.length ?? 0));
    }
  }, [filtersParam]);

  if (filteredArticles.length === 0) {
    return null;
  }

  const [featuredArticle, ...restArticles] = filteredArticles;
  const featuredArticleProps = articleAsProps(
    featuredArticle,
    lang,
    specialPagesValue
  );

  return (
    <>
      {enableTaxonomyFilter && (
        <Container name={ArticleListingSection.name}>
          <TagFilter
            value={selected}
            options={[
              {
                label: t('global:all'),
                value: 'all',
                suffix: `(${totalCount})`
              },
              ...filters
            ]}
            accentColor="--colors-green-700"
            onChange={(value) => {
              setSelected(value);
              // setOffset(articles.length + (data?.length ?? 0));
            }}
          />
        </Container>
      )}
      <Container ref={containerRef} name={ArticleListingSection.name}>
        <NewsGridSection
          /* action={{
            href: '/',
            disabled: isLoading,
            label: t('global:load-more'),
            onClick() {
              // @TODO
            }
          }} */
          featured={
            featuredArticleProps
              ? {
                  ...featuredArticleProps,
                  direction: 'horizontal'
                }
              : undefined
          }
          cards={flush(
            restArticles.map((article) =>
              articleAsProps(article, lang, specialPagesValue)
            )
          )}
        />
      </Container>
    </>
  );
}
